import { useEffect, useRef } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import LogoStrip from './components/LogoStrip';
import WhoItsFor from './components/WhoItsFor';
import InteractiveDemo from './components/InteractiveDemo';
import Testimonials from './components/Testimonials';
import StudentCTA from './components/StudentCTA';
import InstitutionalCTA from './components/InstitutionalCTA';
import Footer from './components/Footer';

export default function LandingPage() {
  const thumbRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const thumb = thumbRef.current;
    if (!thumb) return;

    let timeout: ReturnType<typeof setTimeout>;

    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollFraction = scrollTop / docHeight;
      const thumbHeight = Math.max(window.innerHeight * (window.innerHeight / document.documentElement.scrollHeight), 40);
      const thumbTop = scrollFraction * (window.innerHeight - thumbHeight);

      thumb.style.top = `${thumbTop}px`;
      thumb.style.height = `${thumbHeight}px`;
      thumb.classList.add('visible');

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        thumb.classList.remove('visible');
      }, 1200);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div ref={thumbRef} className="scroll-thumb" />
      <style>{`
        html, body {
          scrollbar-width: none;
        }
        ::-webkit-scrollbar {
          display: none;
        }
        .scroll-thumb {
          position: fixed;
          right: 2px;
          width: 5px;
          border-radius: 3px;
          background: white;
          mix-blend-mode: difference;
          opacity: 0;
          transition: opacity 0.4s;
          z-index: 9999;
          pointer-events: none;
        }
        .scroll-thumb.visible {
          opacity: 1;
        }
      `}</style>
      <Navbar />
      <Hero />
      <LogoStrip />
      <WhoItsFor />
      <InteractiveDemo />
      <Testimonials />
      <StudentCTA />
      <InstitutionalCTA />
      <Footer />
    </div>
  );
}
